var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicator_list"},_vm._l((_vm.list),function(item){return _c('FilterGraphIndicatorsListItem',{key:item.id,attrs:{"item":item},on:{"change-graph":_vm.changeGraph}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }